import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ErrorDisplay from '../../components/BaseComponents/ErrorDisplay';
import Loader from '../../components/BaseComponents/Loader';
import { categorizeError, ErrorInfo } from '../../utils/errorHandler';
import { buildPreScanQuestionnairePdfUrl } from '../../utils/fileDownload';
import { getAccessToken } from '../../utils';
import './PreScanQuestionnairePdf.scss';

const PreScanQuestionnairePdf = () => {
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [errorInfo, setErrorInfo] = useState<ErrorInfo | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [loginRequired, setLoginRequired] = useState(false);

  useEffect(() => {
    const memberId = new URLSearchParams(window.location.search).get('member_id');
    if (!memberId) {
      setErrorInfo(categorizeError({ detail: 'Invalid or missing member link.' }));
      setIsLoading(false);
      return;
    }

    if (!getAccessToken()) {
      setLoginRequired(true);
      setIsLoading(false);
      return;
    }

    const pdfViewUrl = buildPreScanQuestionnairePdfUrl(memberId);
    if (!pdfViewUrl) {
      setLoginRequired(true);
      setIsLoading(false);
      return;
    }

    setPdfUrl(pdfViewUrl);
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return (
      <div className='pre-scan-questionnaire-pdf-page'>
        <Loader height='100vh' />
      </div>
    );
  }

  if (loginRequired) {
    return (
      <div className='pre-scan-questionnaire-pdf-page pre-scan-questionnaire-pdf-login'>
        <p>Please log in to the admin panel to view this questionnaire PDF.</p>
        <Link to='/admin/87431/login'>Go to admin login</Link>
      </div>
    );
  }

  if (errorInfo) {
    return (
      <div className='pre-scan-questionnaire-pdf-page pre-scan-questionnaire-pdf-error'>
        <ErrorDisplay errorInfo={errorInfo} />
      </div>
    );
  }

  return (
    <div className='pre-scan-questionnaire-pdf-page'>
      <iframe
        className='pre-scan-questionnaire-pdf-viewer'
        src={pdfUrl ?? undefined}
        title='Pre-Scan Questionnaire PDF'
      />
    </div>
  );
};

export default PreScanQuestionnairePdf;
